import React from 'react';
import {Outlet} from 'react-router-dom';
import Analytics from '../component/analytics/Analytics';

const RootLayout = () => {
    return (
        <>
            <Analytics />
            <Outlet />
        </>
    );
};

export default RootLayout;
